
import * as mobileLayoutStyles from './MobileLayout.styles';

import DevEnvSwitcher from '../../../DevEnvSwitcher';
import FabNewOrderButton from '../FabNewOrderButton';
import LogoFound from '../../../LogoFound';
import Menu from '../Menu';
import environment from '../../../../utils/environment';
import { AppContextProvider } from '../../../../context/app/AppContext';
import { PrivateRoutePath } from '../../../../utils/routes';

import { useState } from 'react';
import { useRouter } from 'next/router';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';

import type { ReactNode} from 'react';

export interface MobileLayoutProps {
  children?: ReactNode;
}

function MobileLayout({ children }: MobileLayoutProps) {
  const { pathname } = useRouter();

  const { classes } = mobileLayoutStyles.useStyles();

  const [open, setOpen] = useState(false);

  const handleToggleDrawerOpen = () => {
    setOpen(!open);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  // Orders page and pricing plan tab on the profile page
  const isNewOrderButtonVisible = [PrivateRoutePath.ORDERS, PrivateRoutePath.PROFILE].includes(
    pathname as PrivateRoutePath
  );

  return (
    <AppContextProvider isHub>
      <div className={classes.root}>
        <AppBar elevation={0} position="fixed" className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleToggleDrawerOpen}
              edge="start"
              size="large"
            >
              <MenuIcon />
            </IconButton>
            <LogoFound dark />
            {!environment.isProduction && <DevEnvSwitcher chipClasses={classes.chip} />}
          </Toolbar>
        </AppBar>
        <Drawer
          ModalProps={{ onClose: closeDrawer }}
          className={classes.drawer}
          variant="temporary"
          open={open}
          onClose={handleToggleDrawerOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Menu closeDrawer={closeDrawer} />
        </Drawer>
        <main className={classes.content}>
          <div className={`${classes.drawerHeader} ${classes.toolbar}`} />
          {children}
        </main>
        {isNewOrderButtonVisible && <FabNewOrderButton />}
      </div>
    </AppContextProvider>
  );
}

export default MobileLayout;
